export default "__VITE_ASSET__CbDu6qkQ__"